module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/airstrike-toolbar-50.66af9258.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/airstrike-toolbar-50.png
// module id = 3696
// module chunks = 11